<div class="container bg-light position-relative">
    <div class="row">
        <!-- Col Left -->
        <div class="col-lg-8 bg-white pl-0 pr-0 pr-lg-6">
            @if (data) {
                <div class="pl-5 pt-5 pr-5 pr-md-3 pb-3">
                    <div class="row">
                        <div class="col-md-10">
                            <div class="media">
                                @if (data.photo) {
                                    <div class="img-circle img-circle--100 mr-3 rounded-circle mb-1">
                                        <img [src]="cdn + data.photo" [attr.alt]="data.name" height="100" />
                                    </div>
                                }
                                @if (!data.photo && data.participant_logo) {
                                    <div class="img-circle img-circle--100 mr-3 rounded-circle mb-1">
                                        <img [src]="cdn + data.participant_logo" [attr.alt]="data.name" height="100" />
                                    </div>
                                }
                                <div class="media-body">
                                    <h1 class="mb-2" data-cy="player-name">{{ data.name }}</h1>
                                    @if (data.country_name) {
                                        <div class="mb-2 h5 d-flex">
                                            {{ data.country_name }}
                                            <div class="img-circle img-circle--20 ml-2 rounded-circle">
                                                <img
                                                    src="/img/flags/1x1/{{ data.iso | lowercase }}.svg"
                                                    alt="Flag of {{ data.country_name }}"
                                                    height="20"
                                                />
                                            </div>
                                        </div>
                                    }
                                    <div class="font-weight-bold app-white text-body mb-1">
                                        {{
                                            'web.position_' + sportName + '_' + (data.position | lowercase) | translate
                                        }}
                                        @if (data.primary_position && data.position !== data.primary_position) {
                                            <span class="text-muted">
                                                ({{ 'web.primary_position' | translate }}:
                                                {{
                                                    'web.position_' +
                                                        sportName +
                                                        '_' +
                                                        (data.primary_position | lowercase) | translate
                                                }})
                                            </span>
                                        }
                                        @if (data.participant_name) {
                                            ({{ data.participant_name }})
                                        }
                                    </div>
                                    @if (data.participants) {
                                        <div>
                                            @for (p of data.participants; track $index) {
                                                <a
                                                    class="crumb-inline crumb-inline__link"
                                                    [routerLink]="[
                                                        '/page/sport/participant/',
                                                        sportName + '-' + sportId,
                                                        p.id,
                                                    ]"
                                                >
                                                    <img
                                                        src="{{ cdn + p.image | responsive: 'participant' : 'small' }}"
                                                        alt="{{ p.name }}"
                                                        loading="lazy"
                                                        width="20"
                                                        height="20"
                                                        class="img-cover"
                                                    />
                                                    {{ p.name }}</a
                                                >
                                            }
                                        </div>
                                    }
                                    @if (!deviceService.isMobile() && data) {
                                        <div>
                                            @if (data.place_of_birth) {
                                                <span>
                                                    <span class="text-gray"
                                                        >{{ 'web.place_of_birth' | translate }}:</span
                                                    >
                                                    {{ data.place_of_birth }}
                                                </span>
                                            }
                                            @if (data.date_of_birth) {
                                                <span>
                                                    @if (data.place_of_birth) {
                                                        ,
                                                    }
                                                    <span class="text-gray"
                                                        >{{ 'web.date_of_birth' | translate }}:</span
                                                    >
                                                    {{ data.date_of_birth | livDate: 'birthdate' }}
                                                    ({{ data.date_of_birth | livDate: 'age' }}
                                                    {{ 'web.years-old' | translate | transinit }})
                                                </span>
                                            }
                                            @if (data.height) {
                                                <span>
                                                    , <span class="text-gray">{{ 'web.height' | translate }}:</span>
                                                    {{ data.height + ' cm' | unitConversion }}
                                                </span>
                                            }
                                            @if (data.weight) {
                                                <span>
                                                    , <span class="text-gray">{{ 'web.weight' | translate }}:</span>
                                                    {{ data.weight + ' kg' | unitConversion }}
                                                </span>
                                            }
                                            @if (data.preferred_foot) {
                                                <span>
                                                    ,
                                                    @if (!isHockey(sportName)) {
                                                        <span class="text-gray"
                                                            >{{ 'web.preferred_foot' | translate }}:</span
                                                        >
                                                    }
                                                    @if (isHockey(sportName)) {
                                                        <span class="text-gray"
                                                            >{{ 'web.hockey_stick_holding' | translate }}:</span
                                                        >
                                                    }
                                                    {{ 'web.' + data.preferred_foot | lowercase | translate }}
                                                </span>
                                            }
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="nav-wrapper app-scrollable-tabs" style="position: relative">
                    <button
                        class="tabs-scroll-btn tabs-scroll-btn--prev"
                        [class.tabs-scroll-btn--visible]="canScrollLeft"
                        (click)="scrollTabs('left')"
                        aria-label="Scroll tabs left"
                    >
                        <span class="prev"></span>
                    </button>
                    <ul
                        #tabsList
                        class="nav nav-tabs font-weight-bold pt-0"
                        id="tabs-left"
                        role="tablist"
                        (scroll)="onTabsScroll()"
                    >
                        <li class="nav-item">
                            <a
                                class="nav-link active px-3 px-md-5"
                                [class.active]="activeTab == 1"
                                id="tab1"
                                data-toggle="tab"
                                href="#tab1-content"
                                (click)="activeTabFce(1)"
                                role="tab"
                                aria-controls="tab1-content"
                                aria-selected="true"
                                >{{ 'web.overview' | translate | transinit }}</a
                            >
                        </li>
                        <li class="nav-item">
                            <a
                                class="nav-link px-3 px-md-5"
                                [class.active]="activeTab == 2"
                                id="tab2"
                                data-toggle="tab"
                                href="#tab2-content"
                                role="tab"
                                (click)="activeTabFce(2)"
                                aria-controls="tab2-content"
                                aria-selected="false"
                                >{{ 'web.information' | translate | transinit }}</a
                            >
                        </li>
                        @if (deviceService.isMobile() && data.stats.length > 0) {
                            <li class="nav-item">
                                <a
                                    class="nav-link px-3 px-md-5"
                                    [class.active]="activeTab == 3"
                                    id="tab3"
                                    data-toggle="tab"
                                    href="#tab3-content"
                                    role="tab"
                                    (click)="activeTabFce(3)"
                                    aria-controls="tab3-content"
                                    aria-selected="false"
                                    >{{ 'web.statistics' | translate | transinit }}</a
                                >
                            </li>
                        }
                        @if (data.players_transfers && data.players_transfers.length > 0) {
                            <li class="nav-item">
                                <a
                                    class="nav-link px-3 px-md-5"
                                    [class.active]="activeTab == 4"
                                    id="tab4"
                                    data-toggle="tab"
                                    href="#tab1-content"
                                    (click)="activeTabFce(4)"
                                    role="tab"
                                    aria-controls="tab4-content"
                                    aria-selected="false"
                                    >{{ 'web.player-transfers' | translate | transinit }}</a
                                >
                            </li>
                        }
                        @if (data.meta.basic && data.meta.basic.length > 0) {
                            <li class="nav-item">
                                <a
                                    class="nav-link px-3 px-md-5"
                                    data-cy="basic"
                                    [class.active]="activeTab == 5"
                                    id="tab5"
                                    data-toggle="tab"
                                    href="#tab5-content"
                                    role="tab"
                                    (click)="activeTabFce(5)"
                                    aria-controls="tab5-content"
                                    aria-selected="false"
                                    >{{ 'web.basic' | translate | transinit }}</a
                                >
                            </li>
                        }
                        @if (data.has_faceoffs) {
                            <li class="nav-item">
                                <a
                                    class="nav-link active px-3 px-md-5"
                                    [class.active]="activeTab == 8"
                                    id="tab8"
                                    data-toggle="tab"
                                    href="#tab8-content"
                                    (click)="activeTabFce(8)"
                                    role="tab"
                                    [routerLink]="['./']"
                                    fragment="faceoffs"
                                    aria-controls="tab8-content"
                                    aria-selected="true"
                                    >{{ 'web.faceoffs' | translate | transinit }}</a
                                >
                            </li>
                        }
                        <li class="nav-item">
                            <a
                                class="nav-link active px-3 px-md-5"
                                [class.active]="activeTab == 6"
                                id="tab6"
                                data-toggle="tab"
                                href="#tab6-content"
                                (click)="activeTabFce(6)"
                                role="tab"
                                [routerLink]="['./']"
                                fragment="injuries"
                                aria-controls="tab6-content"
                                aria-selected="true"
                                >{{ 'web.injuries' | translate | transinit }}</a
                            >
                        </li>
                        @if (data.has_shot_zones && data.shot_zones.length > 0) {
                            <li class="nav-item">
                                <a
                                    class="nav-link active px-3 px-md-5"
                                    [class.active]="activeTab == 7"
                                    id="tab6"
                                    data-toggle="tab"
                                    href="#tab7-content"
                                    (click)="activeTabFce(7)"
                                    role="tab"
                                    [routerLink]="['./']"
                                    fragment="shot-zones"
                                    aria-controls="tab7-content"
                                    aria-selected="true"
                                    >{{ 'web.shot-zones' | translate | transinit }}</a
                                >
                            </li>
                        }
                    </ul>
                    <button
                        class="tabs-scroll-btn tabs-scroll-btn--next"
                        [class.tabs-scroll-btn--visible]="canScrollRight"
                        (click)="scrollTabs('right')"
                        aria-label="Scroll tabs right"
                    >
                        <span class="next"></span>
                    </button>
                </div>
                <div class="tab-content bg-white px-0 px-lg-3 py-3 has-nomenclature--inside position-relative">
                    <div
                        class="tab-pane active"
                        [class.active]="activeTab == 1"
                        id="tab1-content"
                        role="tabpanel"
                        aria-labelledby="tab1"
                    >
                        <!--Live matches-->
                        @if (dataMatch?.live && dataMatch!.live.length > 0) {
                            <h6
                                class="table-sport__head bg-dark app-text-dark-tournament bg-primary--light"
                                data-toggle="collapse"
                                data-target="#collapse-1-live"
                                role="button"
                                aria-expanded="true"
                                aria-controls="collapse-today"
                            >
                                <span class="table-sport__head__text app-text-dark-tournament">{{
                                    'web.live_matches' | translate
                                }}</span>
                            </h6>
                            <div class="collapse show" id="collapse-1-live">
                                @for (match of dataMatch?.live; track trackById($index, match)) {
                                    <app-component-match
                                        page="'participant'"
                                        [match]="match"
                                        [sportName]="sportName"
                                        [sportId]="sportId"
                                        (onSelect)="loadMatch($event)"
                                    ></app-component-match>
                                }
                            </div>
                        }
                        <!--End Live matches-->
                        <!--Latest matches-->
                        @if (dataMatch?.finished && dataMatch!.finished.length > 0) {
                            <h6
                                class="table-sport__head bg-dark text-white"
                                data-toggle="collapse"
                                data-target="#collapse-1-latest"
                                role="button"
                                aria-expanded="true"
                                aria-controls="collapse-today"
                            >
                                <span class="table-sport__head__text">{{ 'web.latest_matches' | translate }}</span>
                            </h6>
                            <div class="collapse show" id="collapse-1-latest">
                                @for (match of dataMatch?.finished | slice: 0 : 20; track trackById($index, match)) {
                                    <app-component-match
                                        [dateFormat]="'localDate'"
                                        page="'participant'"
                                        data-cy="player-latest"
                                        [match]="match"
                                        [matchActions]="
                                            data.match_actions && data.match_actions[match.id]
                                                ? data.match_actions[match.id]
                                                : null
                                        "
                                        [playerStatistics]="
                                            data.match_statistics && data.match_statistics[match.id]
                                                ? data.match_statistics[match.id]
                                                : null
                                        "
                                        [substitutions]="
                                            data.substitutions &&
                                            data.substitutions[match.id] &&
                                            data.substitutions[match.id].length > 0
                                                ? data.substitutions[match.id]
                                                : null
                                        "
                                        [sportName]="sportName"
                                        [sportId]="sportId"
                                        [participantId]="data.participant_id"
                                        (onSelect)="loadMatch($event)"
                                    ></app-component-match>
                                }
                            </div>
                        }
                        <!--End latest matches-->
                        <!--Not started matches-->
                        @if (dataMatch?.not_started && dataMatch!.not_started.length > 0) {
                            <h6
                                class="table-sport__head bg-dark text-white"
                                data-toggle="collapse"
                                data-target="#collapse-1-not_started"
                                role="button"
                                aria-expanded="true"
                                aria-controls="collapse-today"
                            >
                                <span class="table-sport__head__text">{{ 'web.not_started_matches' | translate }}</span>
                            </h6>
                            <div class="collapse show" id="collapse-1-not_started">
                                @for (match of dataMatch?.not_started | slice: 0 : 20; track trackById($index, match)) {
                                    <app-component-match
                                        [dateFormat]="'localDateTimeShort'"
                                        page="'participant'"
                                        data-cy="player-not_started"
                                        [match]="match"
                                        [sportName]="sportName"
                                        [sportId]="sportId"
                                        (onSelect)="loadMatch($event)"
                                    >
                                    </app-component-match>
                                }
                            </div>
                        }
                        <!--End notstarted matches-->
                        @if (
                            dataMatch?.live?.length == 0 &&
                            dataMatch?.finished?.length == 0 &&
                            dataMatch?.not_started?.length == 0
                        ) {
                            <div class="text-center">
                                <strong>{{ 'web.no_data_found' | translate }}</strong>
                            </div>
                        }
                    </div>
                    <div
                        class="tab-pane"
                        [class.active]="activeTab == 2"
                        id="tab2-content"
                        role="tabpanel"
                        aria-labelledby="tab2"
                    >
                        <div class="match-info-head text-white mb-0 bg-dark p-2 d-flex">
                            <span class="font-weight-bold text-uppercase"> &nbsp; </span>
                        </div>
                        <table class="table table-sm stage-table">
                            @if (data.place_of_birth) {
                                <tr>
                                    <td>{{ 'web.place_of_birth' | translate }}:</td>
                                    <td>{{ data.place_of_birth }}</td>
                                </tr>
                            }
                            @if (data.date_of_birth) {
                                <tr>
                                    <td>{{ 'web.date_of_birth' | translate }}:</td>
                                    <td>{{ data.date_of_birth | livDate: 'date' }}</td>
                                </tr>
                            }
                            @if (data.height) {
                                <tr>
                                    <td>{{ 'web.height' | translate }}:</td>
                                    <td>{{ data.height }} cm</td>
                                </tr>
                            }
                            @if (data.weight) {
                                <tr>
                                    <td>{{ 'web.weight' | translate }}:</td>
                                    <td>{{ data.weight }} kg</td>
                                </tr>
                            }
                            @if (data.high_school) {
                                <tr>
                                    <td>{{ 'web.high_school' | translate }}:</td>
                                    <td>{{ data.high_school }}</td>
                                </tr>
                            }
                            @if (data.college) {
                                <tr>
                                    <td>{{ 'web.college' | translate }}:</td>
                                    <td>{{ data.college }}</td>
                                </tr>
                            }
                            @if (data.draft_year) {
                                <tr>
                                    <td>{{ 'web.draft_year' | translate }}:</td>
                                    <td>
                                        {{ data.draft_year }}
                                        @if (data.draft_participant) {
                                            <span class="text-nowrap">
                                                (<a
                                                    [routerLink]="[
                                                        '/page/sport/participant',
                                                        sportName + '-' + sportId,
                                                        data.draft_participant.id,
                                                    ]"
                                                    class="text-reset table-scrollable-team d-inline"
                                                    >{{ data.draft_participant.name }}</a
                                                >)</span
                                            >
                                        }
                                        @if (data.draft_pick) {
                                            , {{ 'web.pick' | translate }}: {{ data.draft_pick }}
                                        }
                                        @if (data.draft_round) {
                                            , {{ 'web.round' | translate }}: {{ data.draft_round }}
                                        }
                                    </td>
                                </tr>
                            }
                            @if (data.rookie_year && !data.pro_debut) {
                                <tr>
                                    <td>{{ 'web.rookie_year' | translate }}:</td>
                                    <td>{{ data.rookie_year }}</td>
                                </tr>
                            }
                            @if (data.pro_debut) {
                                <tr>
                                    <td>{{ 'web.pro_debut' | translate }}:</td>
                                    <td>{{ data.pro_debut | livDate: 'date' }}</td>
                                </tr>
                            }
                            @if (data.experience) {
                                <tr>
                                    <td>{{ 'web.experience' | translate }}:</td>
                                    <td>{{ data.experience }}</td>
                                </tr>
                            }
                            @if (data.handedness) {
                                <tr>
                                    <td>{{ 'web.handedness' | translate }}:</td>
                                    <td>
                                        {{ 'web.handedness_' + (data.handedness === 1 ? 'right' : 'left') | translate }}
                                    </td>
                                </tr>
                            }
                            @if (data.preferred_foot) {
                                <tr>
                                    @if (!isHockey(sportName)) {
                                        <td>{{ 'web.preferred_foot' | translate }}:</td>
                                    }
                                    @if (isHockey(sportName)) {
                                        <td>{{ 'web.hockey_stick_holding' | translate }}</td>
                                    }
                                    <td>{{ 'web.' + data.preferred_foot | lowercase | translate }}</td>
                                </tr>
                            }
                            @if (data.throw_hand) {
                                <tr>
                                    <td>{{ 'web.throw_hand' | translate }}:</td>
                                    <td>{{ 'web.hand_' + data.throw_hand | translate }}</td>
                                </tr>
                            }
                            @if (data.bat_hand) {
                                <tr>
                                    <td>{{ 'web.bat_hand' | translate }}:</td>
                                    <td>{{ 'web.hand_' + data.bat_hand | translate }}</td>
                                </tr>
                            }
                            @if (data.salary) {
                                <tr>
                                    <td>{{ 'web.salary' | translate }}:</td>
                                    <td>{{ data.salary | number }} USD</td>
                                </tr>
                            }
                            @if (data.awards.length > 0) {
                                <tr>
                                    <td>{{ 'web.awards' | translate }}</td>
                                    <td>
                                        @for (award of data.awards; track $index) {
                                            <span class="d-flex">
                                                <span>{{ award.season.year }}</span>
                                                <span class="mx-2">-</span>
                                                <span>
                                                    {{ award.award.name }}
                                                </span>
                                                @if (award.participant) {
                                                    <ng-container class="">
                                                        <span class="mx-2">-</span>
                                                        @if (award.participant.image) {
                                                            <img
                                                                src="{{ award.participant.image }}"
                                                                alt="{{ award.participant.name }}"
                                                                class="mr-2"
                                                                height="24"
                                                            />
                                                        }
                                                        <a
                                                            [routerLink]="[
                                                                '/page/sport/participant',
                                                                sportName + '-' + sportId,
                                                                award.participant.id,
                                                            ]"
                                                            class="text-reset table-scrollable-team"
                                                        >
                                                            {{ award.participant.name }}
                                                        </a>
                                                    </ng-container>
                                                }
                                                <br />
                                            </span>
                                        }
                                    </td>
                                </tr>
                            }
                        </table>
                    </div>
                    <div
                        class="tab-pane"
                        [class.active]="activeTab == 3"
                        id="tab3-content"
                        role="tabpanel"
                        aria-labelledby="tab3"
                    >
                        <div class="my-2 p-1">
                            <select
                                class="custom-select border-light2"
                                [formControl]="seasonControl"
                                data-cy="player-season"
                            >
                                @for (season of data.seasons; track trackByFnSeason($index, season)) {
                                    <option [value]="season.season_id">
                                        {{ season.season_name }}
                                    </option>
                                }
                            </select>
                        </div>
                        @for (statsRow of data.stats; track $index) {
                            <div>
                                <div class="match-info-head text-white mb-0 bg-dark p-2 d-flex">
                                    <span class="font-weight-bold text-uppercase">
                                        {{ statsRow.tournament_name }}
                                        {{ statsRow.season_name }}
                                        @if (data.stats.length > 1) {
                                            <small>({{ statsRow.participant_name }})</small>
                                        }
                                    </span>
                                </div>
                                <div class="bg-white">
                                    @if (statsRow.has_subtournaments) {
                                        <div class="p-1">
                                            <select
                                                class="custom-select border-light2"
                                                (change)="onSeasonStatsSubtournamentChange($event)"
                                            >
                                                @for (subtournament of statsRow.subtournaments; track $index) {
                                                    <option [value]="subtournament.subtournament_id">
                                                        {{ subtournament.subtournament_name }}
                                                    </option>
                                                }
                                            </select>
                                        </div>
                                    }
                                    <div class="collapse show" id="collapse-drivers">
                                        <div class="table-responsive">
                                            <table class="table table-sm stage-table">
                                                <tbody>
                                                    @for (
                                                        group of getStatsRowData(statsRow) | uni: statsVal | keys;
                                                        track $index
                                                    ) {
                                                        @if (group.key !== 'init') {
                                                            <tr class="bg-light2">
                                                                <td class="small align-middle text-center" colspan="2">
                                                                    {{ 'web.stats_' + group.key | translate }}
                                                                </td>
                                                            </tr>
                                                        }
                                                        @for (attr of group.value | keys; track $index) {
                                                            @if (attr[1] !== null && !isStatIgnored(attr.key)) {
                                                                <tr>
                                                                    <td class="text-nowrap align-middle">
                                                                        {{
                                                                            'web.playerstats_tooltip_' + attr.key
                                                                                | translate
                                                                        }}
                                                                    </td>
                                                                    <td
                                                                        [class.font-weight-bold-extend]="
                                                                            attr.key === 'goals_scored'
                                                                        "
                                                                        class="text-nowrap align-middle"
                                                                    >
                                                                        {{
                                                                            attr.value.value == 0
                                                                                ? '-'
                                                                                : attr.value.value
                                                                        }}
                                                                    </td>
                                                                </tr>
                                                            }
                                                        }
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                    <div
                        class="tab-pane"
                        [class.active]="activeTab == 4"
                        id="tab4-content"
                        role="tabpanel"
                        aria-labelledby="tab4"
                    >
                        <app-player-transfers
                            [playerTransfers]="data.players_transfers"
                            [sportId]="sportId"
                            [sportName]="sportName"
                            [showName]="false"
                        ></app-player-transfers>
                    </div>
                    <div
                        class="tab-pane"
                        [class.active]="activeTab == 6"
                        id="tab6-content"
                        role="tabpanel"
                        aria-labelledby="tab6"
                    >
                        @if (hasGroupedInjuries) {
                            <app-grouped-player-injuries
                                [sportId]="sportId"
                                [sportName]="sportName"
                                [playerId]="data.id"
                            >
                            </app-grouped-player-injuries>
                        }
                        @if (!hasGroupedInjuries) {
                            <app-injuries
                                [sportId]="sportId"
                                [sportName]="sportName"
                                [playerId]="data.id"
                                [showPracticeStatus]="false"
                            >
                            </app-injuries>
                        }
                    </div>
                    <div
                        class="tab-pane"
                        [class.active]="activeTab == 7"
                        id="tab7-content"
                        role="tabpanel"
                        aria-labelledby="tab7"
                    >
                        <app-auth-container
                            [authOff]="!client.use('signin')"
                            permission="premium_stats"
                            [extraPermission]="[
                                'american_sports',
                                'tracker',
                                'stream',
                                'betting_widgets',
                                'stats',
                                'all',
                            ]"
                        >
                            <app-season-player-shot-zones [shot_zones]="data.shot_zones" />
                        </app-auth-container>
                    </div>
                    @if (client.use('seoCard') && data?.player_info) {
                        <div class="card shadow border-0 mt-5">
                            <div class="app-info-card card-body p-0 p-md-5">
                                <div class="media">
                                    <svg class="icon icon--32 mr-3">
                                        <use href="#icon-bulp-2" />
                                    </svg>
                                    <div class="media-body mt-2">
                                        <h6 class="font-weight-bold text-uppercase">{{ data?.name }}</h6>
                                        <div [innerHTML]="data?.player_info | markdown"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    @if (data.meta.basic && data.meta.basic.length > 0) {
                        <div
                            class="tab-pane"
                            [class.active]="activeTab == 5"
                            id="tab5-content"
                            role="tabpanel"
                            aria-labelledby="tab5"
                        >
                            <div class="table-responsive">
                                <div class="match-info__table small pb-2 text-center">
                                    <div class="match-info__table__row player-record bg-dark text-white">
                                        <div class="match-info__table__cell text-left font-weight-bold">&nbsp;</div>
                                        <div class="match-info__table__cell text-left font-weight-bold">&nbsp;</div>
                                    </div>
                                    @for (row of data.meta.basic; track $index) {
                                        <div
                                            class="match-info__table__row app-data-row-data player-record"
                                            data-cy="participant-stats-basic"
                                        >
                                            <div class="match-info__table__cell text-left font-weight-bold border-top">
                                                {{ row.translation | translate }}:
                                            </div>
                                            <div class="match-info__table__cell text-left font-weight-bold border-top">
                                                @if (row.type === 'date') {
                                                    {{ row.value | livDate: 'date' }}
                                                } @else {
                                                    {{ row.value }}
                                                }
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    }
                    @if (data.has_faceoffs) {
                        <div
                            class="tab-pane"
                            [class.active]="activeTab == 8"
                            id="tab8-content"
                            role="tabpanel"
                            aria-labelledby="tab8"
                        >
                            <app-player-faceoffs [sportId]="sportId" [sportName]="sportName" [playerId]="data.id">
                            </app-player-faceoffs>
                        </div>
                    }
                </div>
            } @else {
                <app-placeholder-tournament [progress]="false"></app-placeholder-tournament>
            }
        </div>
        <!-- / Col Left -->
        <!-- Col Right -->
        <div class="col-lg-4 p-3 d-none d-lg-block">
            <div [class.sticky-parent]="stickyDetail">
                @if (
                    data &&
                    data.data.not_started &&
                    data.data.not_started.length > 0 &&
                    data.data.not_started[0].participants.length === 2
                ) {
                    <div class="m-3">
                        <h4 class="font-weight-bold text-uppercase mb-3">
                            @if (data.tournament_logo) {
                                <img
                                    [src]="data.tournament_logo"
                                    [attr.alt]="data.sub_tournament_name"
                                    height="24"
                                    class="mr-2"
                                />
                            }
                            {{ 'web.following_event' | translate }}
                        </h4>
                        <div class="row mb-4 bg-white align-items-center">
                            <div class="col-5">
                                <div class="text-center p-3 h-100">
                                    <div class="img-team img-team--lg img-team--home">
                                        <!-- <svg class="icon icon--12">
                                          <use href="#icon-heart"></use>
                                        </svg> -->
                                        <img
                                            [src]="data.data.not_started[0]?.participants?.[0]?.image"
                                            [alt]="data.data.not_started[0]?.participants?.[0]?.name"
                                            class="img-fluid rounded-circle"
                                        />
                                    </div>
                                    <h5 class="mb-0">
                                        <a
                                            [routerLink]="[
                                                '/page/sport/participant',
                                                sportName + '-' + sportId,
                                                data.data.not_started[0].participants[0].id,
                                            ]"
                                            class="text-reset"
                                        >
                                            {{ data.data.not_started[0].participants[0].name }}
                                        </a>
                                    </h5>
                                    <div class="text-muted">
                                        #{{ data.data.not_started[0].participants[0].table_position }}
                                    </div>
                                </div>
                            </div>
                            <div class="col-2 text-center">
                                <div class="h1 text-light2">vs.</div>
                            </div>
                            <div class="col-5">
                                <div class="text-center p-3 h-100">
                                    <div class="img-team img-team--lg img-team--away">
                                        <img
                                            [src]="data.data.not_started[0].participants[1].image"
                                            [alt]="data.data.not_started[0].participants[1].name"
                                            class="img-fluid rounded-circle"
                                        />
                                        <!-- <svg class="icon icon--12">
                                        <use href="#icon-heart"></use>
                                      </svg> -->
                                    </div>
                                    <h5 class="mb-0">
                                        <a
                                            [routerLink]="[
                                                '/page/sport/participant',
                                                sportName + '-' + sportId,
                                                data.data.not_started[0].participants[1].id,
                                            ]"
                                            class="text-reset"
                                        >
                                            {{ data.data.not_started[0].participants[1].name }}
                                        </a>
                                    </h5>
                                    <div class="text-muted">
                                        #{{ data.data.not_started[0].participants[1].table_position }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                @if (matchId) {
                    <div class="col-right__inner" data-cy="right-column-match">
                        <app-match-detail
                            class="sticky-parent__match"
                            data-cy="player-match-detail"
                            [class.app-match-detail--shadow]="stickyDetail"
                            [style.max-height]="viewPortHeightMatchDetail"
                            [id]="matchId"
                            [matchState]="matchState"
                            [tracker]="tracker"
                            [stream]="stream"
                        ></app-match-detail>
                    </div>
                }
                @if (data) {
                    <!--Tournament name +  filters-->
                    <div class="">
                        <div class="d-flex align-items-end">
                            @if (data.seasons.length > 1) {
                                <div class="flex-grow-1 ml-1 mb-2">
                                    @if (!isMobile) {
                                        <select class="custom-select border-light2" [formControl]="seasonControl">
                                            @for (season of data.seasons; track trackByFnSeason($index, season)) {
                                                <option [value]="season.season_id">
                                                    {{ season.season_name }}
                                                </option>
                                            }
                                        </select>
                                    } @else {
                                        <select class="custom-select border-light2" [formControl]="seasonControl">
                                            @for (season of data.seasons; track trackByFnSeason($index, season)) {
                                                <option [value]="season.season_id">
                                                    {{ season.season_name }}
                                                </option>
                                            }
                                        </select>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                    @for (statsRow of data.stats; track $index) {
                        <div>
                            <div class="match-info-head text-white mb-0 bg-dark p-2 d-flex">
                                <span class="font-weight-bold text-uppercase">
                                    @if (statsRow.participant_logo) {
                                        <img
                                            [src]="cdn + statsRow.participant_logo"
                                            [attr.alt]="statsRow.participant_name"
                                            height="20"
                                            data-toggle="tooltip"
                                            data-placement="top"
                                            [attr.title]="statsRow.participant_name"
                                        />
                                    }
                                    {{ statsRow.tournament_name }}
                                    {{ statsRow.season_name }}
                                    @if (data.stats.length > 1) {
                                        <small>({{ statsRow.participant_name }})</small>
                                    }
                                </span>
                            </div>
                            <div class="bg-white">
                                @if (statsRow.has_subtournaments) {
                                    <div class="p-1">
                                        <select
                                            class="custom-select border-light2"
                                            (change)="onSeasonStatsSubtournamentChange($event)"
                                        >
                                            @for (subtournament of statsRow.subtournaments; track $index) {
                                                <option [value]="subtournament.subtournament_id">
                                                    {{ subtournament.subtournament_name }}
                                                </option>
                                            }
                                        </select>
                                    </div>
                                }
                                <!--<div class="mb-3 px-2 pb-4 bg-white">-->
                                <div class="collapse show" id="collapse-drivers">
                                    <div class="table-responsive">
                                        <table class="table table-sm stage-table">
                                            <tbody>
                                                @for (
                                                    group of getStatsRowData(statsRow) | uni: statsVal | keys;
                                                    track $index
                                                ) {
                                                    @if (group.key !== 'init') {
                                                        <tr class="bg-light2">
                                                            <td class="small align-middle text-center" colspan="2">
                                                                {{ 'web.stats_' + group.key | translate }}
                                                            </td>
                                                        </tr>
                                                    }
                                                    @for (attr of group.value | keys; track $index) {
                                                        @if (attr[1] !== null && !isStatIgnored(attr.key)) {
                                                            <tr>
                                                                <td class="text-nowrap align-middle">
                                                                    {{
                                                                        getPlayerStatTransKey(statsRow, attr.key)
                                                                            | translate
                                                                    }}
                                                                </td>
                                                                <td
                                                                    [class.font-weight-bold-extend]="
                                                                        attr.value.type === 'goals_scored'
                                                                    "
                                                                    class="text-nowrap align-middle"
                                                                >
                                                                    {{
                                                                        attr.value.value == 0 ||
                                                                        attr.value.value === null
                                                                            ? '-'
                                                                            : attr.value.value
                                                                    }}
                                                                </td>
                                                            </tr>
                                                        }
                                                    }
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                }
            </div>
        </div>
        <!-- / Col Right -->
    </div>
</div>
